<template lang="pug">
div.home
  div.banner(

  )
    w-image(
      :src="require('@/assets/header.jpg')"
      width="100%"
      height="100%"
    )
    div.banner-overlay.w-flex.justify-center.column
      div.banner-title.w-flex.column.align-center.justify-center.grow
        h1.banner-title-main Willkommen bei den Schmetterlingen
        div.banner-title-sub Verein zur Bildung, Erziehung und Betreuung von Kleinkindern e.V.
      div.title3.w-flex.justify-center.no-grow
        w-icon(
          style="font-size: 60px; cursor: pointer; margin-bottom: 50px;"
          color="black"
          xl
          @click="scrollToContent"
        ) mdi mdi-chevron-down
  div.home-content
  
    //- NewsEntry(
    //-   backgroundColor="#fcb900"
    //-   height="300px"
    //-   :image="require('@/assets/mitgliederversammlung.png')"
    //-   newsTitle="Einladung zur ordentlichen Mitgliederversammlung"
    //-   newsDate=""
    //- )
    //-   span(style="text-align: justify;")
    //-     p Liebe Schmetterlingseltern, liebe Vereinsmitglieder,
    //-     p &nbsp;
    //-     p wir laden Sie/Dich am Montag den 19. Januar 2025 um 13.10 Uhr in die Räumlichkeiten der Schmetterlinge zu unseren ordentlichen Mitgliederversammlung ein.
    //-     p &nbsp;
    //-     p Tagesordnung:
    //-     ol
    //-       li Begrüßung, Feststellung der Tagesordnung und der Beschlussfähigkeit
    //-       li Neuwahlen (2. Vorstand, Schriftführer, Kassier)
    //-     p &nbsp;
    //-     p Ergänzende Anträge zur Tagesordnung sind bis zum 12. Januar 2026 beim Vorstand einzureichen.
    //-     p Wir freuen uns schon heute auf Euer zahlreicher Erscheinen.
    //-     p &nbsp;
    //-     p Mit freundlichen Grüßen,
    //-     p Der Vorstand der Schmetterlinge
    Sidebyside(
      backgroundColor="white"
      height="300px"
      :image="require('@/assets/vision.jpg')"
      imageLeft
    )
      h1.text-center Unsere Vision
      span(style="text-align: justify;")
        | Wir werden die Schmetterlinge stetig zu einer Einrichtung weiterentwickeln, 
        | in der jedes einzelne Kind seinen Bedürfnissen und seinem Entwicklungsstand 
        | entsprechend begleitet und gefördert wird. Neue wissenschaftliche Erkenntnisse 
        | und bewährte Vorgehensweisen werden gleichermaßen gelebt. Damit werden wir immer 
        | wieder neue Maßstäbe setzen für eine qualitativ hochwertige Kleinkinderbetreuung 
        | in Herrenberg und der gesamten Region – unter Mitwirkung und zum Wohle der 
        | Familien, der Mitarbeiterinnen und aller interessierter Menschen.
    Gallery(
      height="440px"
      header="Unsere Räume"
      :items="gallery"
      backgroundColor="rgb(140,180,180)"
    )
      template(#sub)
        div.text-center
          a(
            @click="activeRoom='Spielzimmer 1'"
          )
            w-tag(
              bg-color="orange"
              style="cursor: pointer;"
            )
              w-icon.mr2(
              ) mdi mdi-rotate-360
              | 360° Ansicht
    Sidebyside(
      backgroundColor="white"
      height="300px"
      :image="require('@/assets/flowers.jpg')"
    )
      h1.text-center Unsere Betreuungszeiten
      span &nbsp;
      span <strong>montags</strong> bis <strong>freitags</strong> von <strong>07:30 Uhr</strong> bis <strong>13:30 Uhr</strong>.
      span &nbsp;
      
      div.w-flex.justify-center(v-if="true")
        div.ferienplan
          h2.text-center(style="font-size: 20px;") Aktuelle Schließzeiten
          div.w-flex.wrap(
            v-for="ferien in ferienplan"
          )
            div.ferien-title.text-bold {{ferien.title}}
            div.ferien-date
              | {{ferien.date_from.toLocaleDateString('de-DE',{year: '2-digit', month: '2-digit', day: '2-digit'})}} 
              template(v-if="ferien.date_to")
                | bis {{ferien.date_to.toLocaleDateString('de-DE',{year: '2-digit', month: '2-digit', day: '2-digit'})}}
      //- span Die Gruppe ist circa sechs Wochen im Jahr geschlossen, in der Regel sind das
      //- ul
      //-   li eine Woche an Pfingsten
      //-   li drei Wochen im August und
      //-   li zwei Wochen an Weihnachten.
      //- span.mt3 Die aktuellen Schließzeiten finden Sie unter 
      //-   router-link(
      //-     :to="{ name: 'Aktuelles' }"
      //-   ) „Aktuelles“
      //-   | .
    Sidebyside(
      backgroundColor="#fcb900"
      height="300px"
      :image="require('@/assets/team.jpg')"
      :imageRoute="{ name: 'Team' }"
      imageLeft
    )
      h1.text-center Unser Team
    Sidebyside(
      backgroundColor="white"
      height="300px"
      :image="require('@/assets/flowers2.jpg')"
    )
      h1.text-center Wie wird man ein Schmetterling?
      span Informationen zur Anmeldung, den Voraussetzungen sowie den Gebühren sind auf der folgenden Seite zusammengetragen.
      w-button.ma1(
        color="black" 
        bg-color="orange"
        :route="{ name: 'Anmeldung' }"
        outline xl
      ) Anmeldung
  w-overlay(
    v-model="activeRoom"
    bg-color="white"
    persistent
    persistent-no-animation
    :opacity="1"
  )
    div.overlay-content.w-flex.column
      div.overlay-header.no-grow.w-flex
        div
          a(
            v-for="room in ['Spielzimmer 1','Spielzimmer 2','Höhlenzimmer']"
            @click="activeRoom=room"
          )
            w-tag.mr2(
              bg-color="orange"
              style="cursor: pointer;"
              :color="room==activeRoom ? 'red' : 'black'"
            ) {{room}}
        w-icon(
          style="cursor:pointer;"
          color="black"
          xl
          @click="activeRoom=undefined"
        ) mdi mdi-window-close
      div.overlay-image.grow
        Image360(
          v-if="activeRoom=='Spielzimmer 1'"
          :src="require('@/assets/gallery/vr_spiel1.jpg')"
        )
        Image360(
          v-else-if="activeRoom=='Spielzimmer 2'"
          :src="require('@/assets/gallery/vr_spiel2.jpg')"
          :yaw="-104"
          :pitch="-10"
        )
        Image360(
          v-else-if="activeRoom=='Höhlenzimmer'"
          :src="require('@/assets/gallery/vr_hoehle.jpg')"
          :yaw="-16"
          :pitch="-3"
        )
</template>

<script>
import { mapGetters } from 'vuex'

import Gallery from '@/components/Gallery';
import Sidebyside from '@/components/Sidebyside';
import NewsEntry from '@/components/NewsEntry';
import Image360 from '@/components/Image360';

export default {
  name: 'Home',
  data() {
    return {
      gallery: [
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel7.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel6.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel5.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel4.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel3.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel2.jpg')},
        {title: 'Spielzimmer', src:require('@/assets/gallery/spiel1.jpg')},
        {title: 'Höhlenzimmer', src:require('@/assets/gallery/hoehle1.jpg')},
        {title: 'Höhlenzimmer', src:require('@/assets/gallery/hoehle2.jpg')},
        {title: 'Höhlenzimmer', src:require('@/assets/gallery/hoehle3.jpg')},
        {title: 'Vesperzimmer', src:require('@/assets/gallery/vesper1.jpg')},
        {title: 'Vesperzimmer', src:require('@/assets/gallery/vesper2.jpg')},
        {title: 'Vesperzimmer', src:require('@/assets/gallery/vesper3.jpg')},
        {title: 'Vesperzimmer', src:require('@/assets/gallery/vesper4.jpg')},
        {title: 'Garten', src:require('@/assets/gallery/garten1.jpg')},
        {title: 'Garten', src:require('@/assets/gallery/garten2.jpg')},
      ],
      ferienplan: [
        {
          title: 'Ostern', 
          date_from: new Date('2026-04-07'), 
        },
        {
          title: 'Pfingsten', 
          date_from: new Date('2026-06-01'), 
          date_to: new Date('2026-06-05'), 
        },
        {
          title: 'Putztag', 
          date_from: new Date('2026-08-07'), 
        },
        {
          title: 'Sommer', 
          date_from: new Date('2026-08-10'), 
          date_to: new Date('2026-08-28'), 
        },
        {
          title: 'Herbst', 
          date_from: new Date('2026-10-30')
        },
        {
          title: 'Weihnachten', 
          date_from: new Date('2026-12-23'), 
          date_to: new Date('2026-01-05'), 
        },
      ],
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      viewport: 'viewport'
    }),
    activeRoom: {
      get() {
        return this.$route.params.activeRoom
      },
      set(value) {
        if (typeof(value) == 'boolean') return;
        if (value) {
          const action = (this.activeRoom) ? 'replace' : 'push'
          this.$router[action]({
            ...this.$route,
            params: {
              activeRoom: value,
              dummy: true
            }
          })
        } else {
          this.$router.go(-1)
        }
      }
    },
  },
  methods: {
    scrollToContent() {
      window.scrollTo({
        top: this.viewport.height-70,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  components: {
    Gallery,
    Sidebyside,
    Image360,
    NewsEntry
  }
}
</script>

<style lang="scss">
.home {
  ol {
    padding-left: 25px;
  }
  .banner {
    height: calc(100vh - 70px);
    width: min(100vw, 1100px);
    position: relative;
    .w-image{
      animation: fadeinout 5s 0s 1;
      animation-iteration-count:infinite;
      opacity: 0.2;
    }
    .banner-overlay {
      .banner-title {
        padding: 30px;
        text-align: center;
        &-main {
          font-size: min(50px, 11vw)!important;
        }
        &-sub {
          font-size: calc(0.4 * min(40px, 7vw));
          font-weight: 500;
        }
      }
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      background-color: rgba(255,255,0,0.2);
    }
  }
  .home-content {
    background-color: white;
  }
  .overlay-content {
    width: 100%;
    height: 100%;
    .overlay-header {
      align-self: stretch;
      padding: 10px;
      justify-content: space-between;
    }
  }
  .ferienplan {
    border: 3px solid rgb(140, 180, 180);
    padding: 10px;
    margin: 10px;
    margin-bottom: 20px;
    .ferien-title {
      min-width: 120px;
      @media only screen and (max-width: 350px) {
        width: 100%;
      }
    }
    .ferien-date {
      white-space: nowrap;
    }
  }
}
@keyframes fadeinout {
    0% { opacity: 0.2; }
    50% { opacity: 0.7; }
    100% { opacity: 0.2; }
}
</style>
